import { Box } from '@factorialco/deprecated-design-system'
import { GoalsGoalConfigPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import Banner from 'modules/goals/pages/performance/GoalPage/Banner'
// TODO: using private components from another page
import Content from 'modules/goals/pages/performance/GoalPage/Content'
import goals from 'modules/goals/store/collections/goals'
import goalsConfig from 'modules/goals/store/collections/goalsconfig'
import Page from 'modules/layout/components/Page'
import Header from 'modules/layout/components/Page/Header'

interface Props {
  id?: string
  goalConfigId?: string
  contractVersions: ContractVersions
}

const GoalConfigPage = ({ id, goalConfigId, contractVersions }: Props) => {
  const { navigation } = useNavigation()

  const { loading: loadingAsyncData } = useAsyncData(() => {
    return Promise.all([
      goalsConfig.fetch(),
      goals.fetch({
        data: {
          goal_config_id: goalConfigId,
        },
      }),
    ])
  }, [id])

  const { loading: loadingGraphQl, data } = useQuery(GoalsGoalConfigPageDocument)
  const canSeeClockedIn = data?.attendance._policies.companySeeClockedIn.can || false

  const loading = loadingAsyncData || loadingGraphQl

  const goalConfig = goalsConfig.find({
    id: Number(goalConfigId),
  })

  const name = goalConfig ? goalConfig.attributes.name : i18n.t('surveys.goals.common.goal')

  return goalConfig ? (
    <Page isLoading={loading}>
      <Page.Header>
        <Header.Title backTo={navigation.employees.id.goals.fullPath({ id: Number(id) })}>
          {name}
        </Header.Title>
      </Page.Header>
      <Page.Body>
        <Box gap="s32">
          <Banner goalConfig={goalConfig} />
          <Content
            goalConfig={goalConfig}
            canSeeClockedIn={canSeeClockedIn}
            contractVersions={contractVersions}
          />
        </Box>
      </Page.Body>
    </Page>
  ) : null
}

export default observer(GoalConfigPage)
